import { useState, useEffect, FunctionComponent, useRef } from 'react';
import { Button } from '../../tailwindcomponents';
import { Typography, Table, TableRow, TableCell } from './../../tailwindcomponents';
import { CertificateData, Certificates, RatingsDifference } from './../../types/certificates'
import { RemoveCircle } from '../../components/icons';
import Certificate from './Certificate';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import CertificatesApi from './../../api/certificates';
import ProfileImg from '../../components/Images/ProfileImg';

type CertificateProps = {
    setLoading: Function,
}

const WaitingForApproval: FunctionComponent<CertificateProps> = ({ setLoading }) => {
    const [certificatesPending, setCertificatesPending] = useState<Array<Certificates>>([]);
    const [selectedCertificate, setSelectedCertificate] = useState<CertificateData>();
    const [order_by_text, setOrderByText] = useState<string>("created_date");
    const [ascending, setAscending] = useState<boolean>(true);
    const [approver, setApprover] = useState<boolean>(true);
    const ratingsDifference = useRef<RatingsDifference>({ oldRatings: [], newRatings: [], userName: "" });

    const store = useSelector((state: RootState) => state);
    const userGroups = store.user.me.user_clearence_groups;
    const users = store.employees.all_employees;

    useEffect(() => {
        if (userGroups !== undefined) {
            if (userGroups.includes("Certificates Approver")) {
                setApprover(true);
            }
            else {
                setApprover(false);
            }
        }
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userGroups]);

    const refresh = () => {
        setLoading(true);
        CertificatesApi.GetAllCertificateWaitingApproval().then(res => {
            setCertificatesPending(res.data);
            setLoading(false);
        })
    }

    const generateTableBody = (row: Certificates, index: number) => {
        return (
            <TableRow onClick={() => onRowClick(row)} >
                <TableCell>{index}</TableCell>
                <TableCell wrap={false}>
                    <div className="flex items-center gap-2">
                        <ProfileImg imgKey={index} imgSize="xs" userName={users?.find(s => s.Id === row.mechanic_employee_id)?.userName?.split('@')[0]} />
                        <Typography align="left" display="inline" text={row.mechanic_full_name}></Typography>
                    </div>
                </TableCell>
                <TableCell>{row.created_date_text}</TableCell>
                <TableCell>
                    {row.declined_reason !== '' &&
                        <div className="flex"> <RemoveCircle className="mr-2" color="error" />  <Typography paragraph={false} text={row.declined_reason} />  </div>}
                </TableCell>
                <TableCell>
                    {row.declined_reason === '' &&
                        <Button variant="contained" onClick={() => onRowClick(row)}>{approver ? "Review" : "Edit"}</Button>
                    }
                </TableCell>
            </TableRow>
        )
    }
    const onRowClick = (row: Certificates) => {
        CertificatesApi.ReturnDifferenceBetweenTwoCertificates(row.certificate_id).then(res => {
            setSelectedCertificate({
                ...res.data,
                certificate_expired_date_text: row.certificate_expired_date_text,
                expired_date_status: row.expired_date_status,
            });
            ratingsDifference.current.newRatings = res.newRatingIds;
            ratingsDifference.current.oldRatings = res.oldRatingIds;
            ratingsDifference.current.userName = store.employees?.all_employees?.find(emp => emp.Id === row.mechanic_employee_id)?.userName.split('@')[0] || "";
        })
    }
    const closeCertificate = () => {
        refresh();
        setSelectedCertificate(undefined);
    }
    const OnOrderByTitles = (givenOrderByText: string) => {
        let tempAscending = true;
        if (order_by_text === givenOrderByText) { tempAscending = ascending === false ? true : false; }
        setAscending(tempAscending);
        setOrderByText(givenOrderByText);
    }

    return (
        <div>
            {selectedCertificate === undefined ? <div>
                <div>
                    {certificatesPending !== undefined ?
                        <Table
                            headers={["Employee Name", "Approval requested date", "Declined Reason", ""]}
                            rows={certificatesPending}
                            generateBody={(row: any, index: number) => generateTableBody(row, index)}
                            OnOrderByTitles={(orderByText: string) => OnOrderByTitles(orderByText)}
                            pagination={false}
                        />
                        :
                        <Typography text="No certificates are currently pending approval" variant="h3" fontWeight="bold" align="center" />
                    }
                </div>
            </div>
                :
                <div>
                    <Certificate
                        setLoading={(loadingStatus: boolean) => setLoading(loadingStatus)}
                        selectedCertificate={selectedCertificate}
                        setSelectedCertificate={setSelectedCertificate}
                        ratingsDifference={ratingsDifference.current}
                        closeCertificate={() => closeCertificate()}
                        viewType={approver ? 'approval' : 'edit'}
                        userType={"CertAdmin"}
                    />
                </div>
            }
        </div>
    );
};
export default WaitingForApproval;
